module.exports = __webpack_public_path__ + "static/img/app.6e02d85f.png";